export const blogPosts = [
  {
    title: "Things learned in january 2025",
    preview: "Everything I learning during january 2025",
    description: "How I started my journey in the world of data and what I've learned so far.",
    fullContent: 
`My journey into data science began with a simple curiosity about how machines could learn from data

The real breakthrough came when I started working with machine learning models. From simple linear regression to complex neural networks, each new concept opened up exciting possibilities. I spent countless hours experimenting with different algorithms, tweaking parameters, and learning from both successes and failures.

Tech stack:
- PaddleOCR
- Ollama server
- Mistral API
- hugging face inference endpoint

`,
    image: "/src/Assets/Bender_Rodriguez.png",
    link: "#"
  }
]; 